import { Maybe } from '@iss/libs/graphql';
import { RouterLink } from '@angular/router';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'wo-labelled-field',
  templateUrl: './labelled-field.component.html',
  styleUrls: [ './labelled-field.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgIf,
    RouterLink,
  ],
})
export class LabelledFieldComponent {
  @Input() public label: Maybe<string>;
  @Input() public value?: unknown;
  @Input() public important?: boolean;
  @Input() public reversed?: boolean;
  @Input() public bold?: boolean;
  @Input() public horizontal?: boolean;
  @Input() public noWrap?: boolean;
  @Input() public link?: unknown[];
}
